export default class ServiceDeliveryLocationDomainService {
    static fromJSON(json) {
        return Object.assign({}, json);
    }
}
